import GoogleAnalytics from './GoogleAnalytics';

export default GoogleAnalytics;
